// extracted by mini-css-extract-plugin
export default {"form":"ProductItemForm_form__PvWbQ"};